import React from 'react';
import { Form, Input, Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

type Props = {
  loading: boolean;
  errMsg: string;
	onClickSignUp?: Function;
  onSubmit: Function;
};

const LoginForm = (props: Props) => {	
  const onFinish = (values: any) => {
    if (props.onSubmit)
      props.onSubmit(values.email, values.password);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 10 }}
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      {props.errMsg 
        && <p style={{ textAlign: 'left', color: 'tomato' }}>{props.errMsg}</p>}

      <Form.Item
        label="Email"
        name="email"
        rules={[{ required: true, message: 'Please input your email!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item>
        {!props.loading && <Button className="login-form-button" type="primary" htmlType="submit">
          Submit
        </Button>}
        {props.loading && <Button className="login-form-button" type="primary">
          <LoadingOutlined />
        </Button>}
        {props.onClickSignUp && <span style={{ marginLeft: '5px' }}>
        		or <Button onClick={() => props.onClickSignUp && props.onClickSignUp()}>Sign Up</Button>
        	</span>}
      </Form.Item>
    </Form>
  );
};

export default LoginForm;